(function () {
  function initCarousel(root) {
    if (!root || root.dataset.waCarouselReady === 'true') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-wa-slide]'));
    if (!slides.length) return;

    root.dataset.waCarouselReady = 'true';
    var current = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
    var dotsWrap = root.querySelector('[data-wa-dots]');
    var prev = root.querySelector('[data-wa-prev]');
    var next = root.querySelector('[data-wa-next]');
    var dots = [];
    var timer = null;
    var autoplay = root.dataset.autoplay !== 'false' && slides.length > 1;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (autoplay) timer = window.setInterval(function () { show(current + 1); }, 6500);
    }

    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'wa-story-carousel__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () { show(i); start(); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    if (prev) prev.addEventListener('click', function () { show(current - 1); start(); });
    if (next) next.addEventListener('click', function () { show(current + 1); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    show(current);
    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wa-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
